<template>
  <div class="case-detail-gene-clinvar-data-page col-block width-full" :style="{ flex: 1 }">
    <div class="data-container col-block width-full" v-for="(variant, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ width: '10px' }"></div>
        <a v-if="variant.ClinVar_URL" :href="variant.ClinVar_URL" target="_blank">
          <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
        </a>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="data-content-container col-block width-full">
        <div class="data-content-block col-block width-full" v-for="(optionGroup, gindex) in tableOptionGroups" :key="gindex">
          <div class="data-row-container col-block width-full">
            <div class="data-row row-block stretch">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" v-html="option.title"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
            <div class="data-row row-block stretch">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" :style="option.color ? { color: option.color(variant) } : {}" v-html="option.value(variant) || option.empty || '- -'"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clinvar-statistic-container col-block width-full">
      <div class="clinvar-statistic-title-container row-block">
        <div class="clinvar-statistic-title">{{ $t('COMPONENT.caseDetail.geneClinvarData.___clinvarStatisticTitle') }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <clinvarStatisticTable
        v-if="clinvarStatistic"
        :defaultData="clinvarStatistic"
      ></clinvarStatisticTable>
    </div>
    <div :style="{ height: 0 }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ $t('COMMON.button.___return') }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import clinvarStatisticTable from '../case/clinvarStatisticTable.vue'
import { defaultEmptyDisplay, getClinvarACMGMapDatas } from '../../constants/global/data'

export default {
  components: {
    clinvarStatisticTable
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    clinvarStatistic () {
      return this.param.clinvarStatistic
    },
    // static
    tableOptionGroups () {
      const clinvar = {
        title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.___title'),
        link: variant => variant.ClinVar_URL,
        options: [
          {
            title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___interpretation'),
            value: variant => getClinvarACMGMapDatas(variant.CLIN_SIG).map(data => '<span' + (data.display === defaultEmptyDisplay.empty ? '' : ' style="color:' + data.color + ';"') + '>' + this.$t(data.display) + '</span>').join(',<br>'),
            color: null,
            width: '200px',
            position: 'center',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___reviewStatus'),
            value: variant => variant.ClinVar_CLNREVSTAT ? variant.ClinVar_CLNREVSTAT.split(',').map(value => value.replace(/_/g, ' ')).join(',<br>') : null,
            color: null,
            width: '250px',
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___condition'),
            value: variant => variant.ClinVar_Disease_Name ? variant.ClinVar_Disease_Name.split('|').map(value => value.replace(/_/g, ' ')).join(',<br>') : null,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          },
          {
            title: this.$t('COMPONENT.caseDetail.geneClinvarData.table.clinvar.title.___conflicts'),
            value: variant => variant.CLIN_CONF ? variant.CLIN_CONF.split(',').map(value => value.replace(/_/g, ' ')).join(',<br>') : null,
            color: null,
            width: null,
            position: 'left',
            empty: this.$t(defaultEmptyDisplay.empty)
          }
        ]
      }
      return [
        clinvar
      ].filter(x => x)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/geneClinvarData.vue